import { useContext } from 'react';

import MultiAccountsContext from './MultiAccountsContext';

const useMultiAccounts = () => useContext(MultiAccountsContext);

export default useMultiAccounts;
